import React, { FC, useCallback } from 'react';
import { ActionIcon, Flex, Switch, Table } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { EditIcon } from '@assets/icons';
import { DlpProfile } from '@/services/api/dlpSettingsApiArea/types';
import { PopUpUI } from '@components/UI/PopUp';
import DeleteDlpDialog from '../components/DeleteDlpDialog';

interface DlpItemProps {
  profile: DlpProfile;
  onEdit: (id: number) => void;
  onDelete: () => Promise<void>;
  onToggle: (enabled: boolean) => void;
}

export const DlpItem: FC<DlpItemProps> = ({ profile, onEdit, onDelete, onToggle }) => {
  const handleToggle = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onToggle(event.currentTarget.checked);
    },
    [onToggle]
  );

  const DeleteTrigger = useCallback(
    ({ setIsOpen }: { setIsOpen: (value: boolean) => void }) => (
      <ActionIcon onClick={() => setIsOpen(true)}>
        <IconTrash />
      </ActionIcon>
    ),
    []
  );

  return (
    <Table.Tr style={{ position: 'relative' }}>
      <Table.Td style={{ width: '100%' }}>{profile.Server?.Name}</Table.Td>
      <Table.Td>
        <Switch checked={profile.Enabled} onChange={handleToggle} />
      </Table.Td>
      <Table.Td style={{ width: 60, maxWidth: 60 }}>
        <Flex gap={4} justify="flex-end">
          <ActionIcon onClick={() => onEdit(profile.Id)}>
            <EditIcon />
          </ActionIcon>
          <PopUpUI mobileSize="100%" desktopPosition="bottom-end" trigger={DeleteTrigger}>
            {({ isOpen, setIsOpen }) => (
              <DeleteDlpDialog
                profileId={profile.Id}
                profileName={profile.Server?.Name || ''}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                onSuccess={onDelete}
              />
            )}
          </PopUpUI>
        </Flex>
      </Table.Td>
    </Table.Tr>
  );
};
